const initialState = {
  isRequestingMotivosRechazo: true,
  motivosRechazo: [],
  motivoRechazo: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MOTIVO_RECHAZO':
      return {
        ...state,
        motivoRechazo: action.motivoRechazo || null
      }
    case 'REQUEST_MOTIVOS_RECHAZO':
      return {
        ...state,
        isRequestingMotivosRechazo: true
      }
    case 'RECEIVE_MOTIVOS_RECHAZO':
      return {
        ...state,
        isRequestingMotivosRechazo: false,
        motivosRechazo: action.motivosRechazo
      }
    default:
      return state
  }
}
